// SPDX-FileCopyrightText: 2026 Stadtplatz.de
//
// SPDX-License-Identifier: EUPL-1.2

/**
 * Standard date ranges with days property
 * Used by: LLM Usage Reports, API Analytics, Business Metrics Dashboard
 */
export const STANDARD_DATE_RANGES = [
  { label: "Today", days: 1 },
  { label: "Last 7 days", days: 7 },
  { label: "Last 30 days", days: 30 },
  { label: "Custom Range", days: null },
];

/**
 * Date ranges without custom option
 * Used by: Risk & LLM Analysis
 */
export const SIMPLE_DATE_RANGES = [
  { label: "Last 24 hours", days: 1 },
  { label: "Last 7 days", days: 7 },
  { label: "Last 30 days", days: 30 },
];

/**
 * Date filter options with value property
 * Used by: Bookings page
 */
export const DATE_FILTER_OPTIONS = [
  { label: "Today", value: "today" },
  { label: "Last 7 days", value: "last_7_days" },
  { label: "Last 30 days", value: "last_30_days" },
  { label: "Custom Range", value: "custom" },
];

/**
 * Time-based ranges (strings)
 * Used by: Admin Dashboard
 */
export const TIME_RANGES = ["Last 1 hour", "Last 4 hours", "Last 24 hours"];

/**
 * Get default selected range for standard ranges
 */
export const getDefaultStandardRange = () => STANDARD_DATE_RANGES[0];

/**
 * Get default selected range for simple ranges
 */
export const getDefaultSimpleRange = () => SIMPLE_DATE_RANGES[1]; // Default to "Last 7 days"

/**
 * Get default selected range for date filter options
 */
export const getDefaultDateFilter = () => DATE_FILTER_OPTIONS[0];

/**
 * Get default selected range for time ranges
 */
export const getDefaultTimeRange = () => TIME_RANGES[0];
